(function(window, tokenServiceDefinition) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.tokenService = tokenServiceDefinition(
      window.$,
      window.Q,
      namespace.HttpService);
})(this, function($, Q, HttpService) {
   'use strict';

   var httpService = HttpService.create();

   var getTechSmithAccessToken = function(playerConfiguration) {
      var accessTokenEndpoint = playerConfiguration.getTechSmithAccessTokenEndpoint();
      if (accessTokenEndpoint) {
         return httpService.get(accessTokenEndpoint).then(function(data) {
            return data.AccessToken;
         });
      }
      return Q();
   };

   return {
      getTechSmithAccessToken: getTechSmithAccessToken
   };
});
